import React from 'react';

import { HelperMessage } from '@atlaskit/form';
import InfoIcon from '@atlaskit/icon/glyph/info';

import { Text, Wrapper } from './InfoMessage.styled';

type Props = {
  children: string;
};

export default function InfoMessage({ children }: Props): JSX.Element {
  return (
    <Wrapper>
      <HelperMessage>
        <InfoIcon size='small' label='' />
        <Text>{children}</Text>
      </HelperMessage>
    </Wrapper>
  );
}
